module.exports = __webpack_public_path__ + "static/subscriptionOther-adee5162256136a845fee6b223094954.jpg";